/**
 * useApiKey
 *
 * APIキーの読み出し・保存・削除を一括で扱うフック。
 *
 * ・初回マウント時に localStorage から読み込む
 * ・保存/削除時は localStorage と React ステートの両方を更新
 * ・「キーが入っているかどうか」を hasApiKey で公開
 */

import { useCallback, useEffect, useState } from 'react';

import * as storage from '../lib/storage';

export interface UseApiKeyResult {
  /** 現在のAPIキー（未設定時 null） */
  apiKey: string | null;
  /** APIキーが設定されているか */
  hasApiKey: boolean;
  /** APIキーを保存（localStorageと内部stateの両方を更新） */
  saveApiKey: (key: string) => void;
  /** APIキーを削除 */
  clearApiKey: () => void;
}

export function useApiKey(): UseApiKeyResult {
  // SSRはしないが、StrictModeの初回レンダー時は localStorage が空なので null から始める
  const [apiKey, setApiKey] = useState<string | null>(null);

  // マウント時に1回だけ localStorage を読む
  useEffect(() => {
    setApiKey(storage.getApiKey());
  }, []);

  const saveApiKey = useCallback((key: string) => {
    storage.saveApiKey(key);
    setApiKey(key.trim());
  }, []);

  const clearApiKey = useCallback(() => {
    storage.clearApiKey();
    setApiKey(null);
  }, []);

  return {
    apiKey,
    hasApiKey: apiKey !== null && apiKey.length > 0,
    saveApiKey,
    clearApiKey,
  };
}
